import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './CloseSticky.scss';

function CloseSticky({ timeout, closeMiniTvWidget, hide, parentCss }) {
  const [seconds, setSeconds] = useState(timeout);
  const isHidden = hide ? s.hide : '';
  useEffect(
    () => {
      let timer;
      if (seconds > 0) {
        timer = setTimeout(() => {
          setSeconds(prevSeconds => prevSeconds - 1);
        }, 1000);
      }
      return () => clearTimeout(timer);
    },
    [seconds],
  );

  const updateStickyClass = type => {
    try {
      document.querySelector('body').classList[type]('stick_minitv_top');
    } catch (error) {
      //
    }
  };

  useEffect(() => {
    updateStickyClass('add');
    return () => updateStickyClass('remove');
  }, []);
  return (
    <div
      className={`${s.autoClose} ${isHidden} ${parentCss.autoClose}`}
      data-no-drag="1"
    >
      {seconds ? (
        <span className={s.autoCloseTimer}>
          <span className={s.grayBorder}>
            <span className={s.timer}>{seconds}</span>
          </span>
          <svg viewBox="0 0 36 36" className={`${s.circularChart}`}>
            <path
              className={s.circle}
              strokeDasharray="60, 100"
              d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
            />
          </svg>
        </span>
      ) : (
        <span
          className={s.closeBtn}
          onClick={() => closeMiniTvWidget()}
          data-no-drag="1"
        />
      )}
    </div>
  );
}
CloseSticky.propTypes = {
  timeout: PropTypes.number,
  closeMiniTvWidget: PropTypes.func.isRequired,
};
CloseSticky.defaultProps = {
  timeout: 0,
};
export default CloseSticky;
